<template>
  <v-card>
    <v-img
      class="align-end"
      :src="productImage"
      :aspect-ratio="4 / 3"
      gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.1)"
    >
      <product-cart-price-tag
        :calculatedPrice="calculatedPrice"
        :deposit="product.deposit"
        :showPriceWithoutDph="mobConfig.showPriceWithoutDPH"
      ></product-cart-price-tag>
    </v-img>
    <v-card-title>
      {{ product.title }}
    </v-card-title>
    <v-card-subtitle class="pb-0">
      <span v-if="productSizes">{{ $t("Velikosti") }}: {{ productSizes }}</span>
    </v-card-subtitle>

    <v-card-text v-if="product.sets.items.length > 0" class="text--primary">
      <h3>Výhodné balíčky</h3>
      <v-chip v-for="item in product.sets.items" :key="item.set.id">
        {{ item.set.title }}
      </v-chip>
    </v-card-text>

    <v-card-actions>
      <v-btn color="light-green" v-on:click="bookTheProduct" block>
        Rezervovat
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PriceCalculator from "@/libs/PriceCalculator";
import ProductCartPriceTag from "@/components/ProductCartPriceTag";
import moment from "moment";

export default {
  name: "RentProductCard",

  components: {
    ProductCartPriceTag,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    calculatedPrice: function () {
      if (
        this.product != undefined &&
        this.product.priceTables != undefined &&
        this.product.priceTables.length > 0
      ) {
        let price = PriceCalculator.findPrice(
          this.product.priceTables,
          "DAILY",
          this.length,
          1,
          this.mobConfig.rentDiscountPercent
        );

        return price;
      } else {
        return "";
      }
    },

    checkInDate() {
      return this.$store.state.checkInDate;
    },

    checkOutDate() {
      return this.$store.state.checkOutDate;
    },

    length() {
      return moment(this.checkOutDate).diff(this.checkInDate, "days") + 1;
    },

    productImage: function () {
      if (this.product.images == undefined) {
        return null;
      }
      if (this.product.images.length < 1) {
        return null;
      }
      return this.product.images[0];
    },

    productSizes: function () {
      if (this.product.sizes == undefined) {
        return null;
      }
      if (this.product.sizes.length < 1) {
        return null;
      }

      if (this.product.sizes.length > 5) {
        let head = [];
        head.push(this.product.sizes[0]);
        head.push(this.product.sizes[1]);
        head.push("...");
        head.push(this.product.sizes[this.product.sizes.length - 2]);
        head.push(this.product.sizes[this.product.sizes.length - 1]);

        return head.join(", ");
      }

      return this.product.sizes.join(", ");
    },
  },

  methods: {
    bookTheProduct() {
      this.$emit("bookProduct", this.product);
    },
  },
};
</script>
